import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { CommonService, SharedserviceService } from 'src/app/services';
import { DatePipe } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DateAdapter } from '@angular/material';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  providers: [DatePipe]
})
export class PaymentComponent implements OnInit {
  bill_id: any = '';
  acc_bill_no: any = '';
  bodydata: any = {};
  addNewBill: FormGroup;
  sendRequest: FormGroup;
  public editBill: FormGroup;
  sent_data: any;
  keys: any;
  forApi: boolean = false
  submitted: boolean = false;
  minDate: any;
  maxDate: any;
  date: any;
  dataId: any
  fromDate: any = '';
  toDate: any = '';
  editBillData: any
  Type: any;
  today:any=new Date();
  TotalCount: string;
  TTotalCount: string;
  data: any;
  Tdata: any;
  public page: number = 1;
  start = 0;
  msg: any;
  FormId: any;
  flag: boolean = false;
  today_date: Date;
  userdata:any;
  Imgurl:any;
  RqstData:any;
  public Rqstform: FormGroup;
  requesttype:any='credit';
  
  public imagePath;
  imgFile: File=null;
  public message: string;
  usertype:any='balance';
  image:any;
  zoomimage:any;
  btndisabled: boolean=false;
  public imgMessage: string;
  userAgency: any;
  File: File=null;  
  NoOfStopData=[
    { id: 'cash', name: "CASH" },
    { id: 'cheque', name: "CHEQUE" },
    { id: 'rtgs', name: "RTGS" },
    { id: 'neft', name: "NEFT" },
    { id: 'imps', name: "IMPS" }
  ]
  viewList: any;

  constructor(public sharedService: SharedserviceService,
    private fb: FormBuilder,
    public router: Router,
    private toastr: ToastrManager,
    public datepipe: DatePipe,
    private ngxLoader: NgxUiLoaderService,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<Date>,
    public commonService: CommonService,
    public activatedRoute: ActivatedRoute) {
      this.userAgency = JSON.parse(localStorage.getItem('userAgency_padmawati'));

    this.activatedRoute.params.forEach((urlParams) => {
      this.Type = urlParams['type'];
      this.bodydata = {
        page_limit: 10,
        page_no: 1,
        order_key: "id",
        sort_order: "asc",
        status: ""
      }
      this.showList(this.bodydata);
      this.userdata=JSON.parse(localStorage.getItem("user"));
    });
    this.today_date = new Date()
  }

  get f() { return this.Rqstform.controls; }

  ngOnInit() {
    this.sendRequest = this.fb.group({
      type: ['balance', Validators.required],
      amount: ['', Validators.required],
      mode: ['', Validators.required],
      reference: ['', Validators.required],
      image: [''],
      comment: ['']
    });
    this.bodydata = {
      page_limit: 10,
      page_no: 1,
      order_key: "id",
      sort_order: "asc",
      status: ""
    }
    this.Rqstform = this.fb.group({
      id: [''],
      accept: [''],
      response: [''],
      credit_reversal_date: [''],
    });
    
    // this.addNewBill= this.fb.group({
    //   prefix: ['',Validators.required],
    //   method: ['',Validators.required],
    //   from_date: ['',Validators.required],
    //   to_date: ['',Validators.required],
    //   for_api: [false],
    //   for_website: [false],
    //   share_api: [false],
    //   share_website: [false]

    // })
    // this.editBill = this.fb.group({
    //   id:['', Validators.required],
    //   status:[''],
    //   prefix: ['',Validators.required],
    //   method: ['',Validators.required],
    //   from_date: ['',Validators.required],
    //   to_date: ['',Validators.required],
    //   for_api: [false],
    //   for_website: [false],
    //   share_api: [false],
    //   share_website: [false]
    // })
  }


  showList(request) {
    // if (type == 'sent') {
      this.sharedService.post('v1/request/sent_list', request).subscribe((res: any) => {
        if (res.replyCode == "success") {
          this.sent_data = res.data;
          this.Imgurl=res.url;
          this.sent_data.forEach(element => {
            if(element.status == '0'){
              element.payment_status="Decision pending"
            }else if(element.status == '1'){
              element.payment_status="Removed by you"
            }else if(element.status == '2'){
              element.payment_status="Accepted"
            }else{
              element.payment_status="Rejected"
            }
          });
          this.TotalCount = res.totalRecords;
          this.keys = Object.keys(this.sent_data[0]);
        }
      }, err => {
        this.toastr.errorToastr(err.replyMsg)
      })
   }

  removerequest(data){
    var request={
        id: data.id
    }
    this.sharedService.post('v1/request/remove', request).subscribe((res: any) => {
      if (res.replyCode == "success") {
        this.showList(this.bodydata);
      }
    }, err => {
      this.toastr.errorToastr(err.replyMsg)
    })
  }

  recievedAction(data){
    this.RqstData= data
    if(data.type == 'credit'){
      this.requesttype='credit';
      this.Rqstform = this.fb.group({
        id: [data.id, Validators.required],
        accept: [false, Validators.required],
        response: ['', Validators.required],
        credit_reversal_date: ['', Validators.required],
      });
    }
    else{
      this.requesttype='balance'
      this.Rqstform = this.fb.group({
        id: [data.id, Validators.required],
        accept: [false, Validators.required],
        response: ['', Validators.required],
      });
    }  
    $('#actionmodal').modal('show');
  }

  ActionSubmit(){
    this.submitted = true;
    let requestdata=this.Rqstform.value;
    if(this.Rqstform.invalid){
      return;
    }else{
      // console.log("Check Action Data::::::::::::",requestdata)
      var request={
        id: requestdata.id,
        accept: requestdata.accept,
        response: requestdata.response,
        credit_reversal_date: this.datePipe.transform(requestdata.credit_reversal_date, 'yyyy-MM-dd')
      }

      console.log("Check Action Data::::::::::::",request)
      this.sharedService.post('v1/request/action', request).subscribe((res: any) => {
        if (res.replyCode == "success") {
            this.Rqstform.reset();
            this.submitted=false;
            $('#actionmodal').modal('hide');
            this.showList(this.bodydata);
        }
      }, err => {
          this.Rqstform.reset();
          this.submitted=false;
          $('#actionmodal').modal('hide');
          this.toastr.errorToastr(err.replyMsg)
      })
    }

  }


  // onSearch() {
  //   if (this.fromDate != '') {
  //     this.fromDate = this.datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd');
  //   } else {
  //     this.fromDate = ''
  //   }
  //   if (this.toDate != '') {
  //     this.toDate = this.datePipe.transform(new Date(this.toDate), 'yyyy-MM-dd');
  //   } else {
  //     this.toDate = ''
  //   }
  //   var request = {
  //     page_limit: '10',
  //     page_no: 1,

  //     sortorder: "desc",
  //     fromDate: this.fromDate,
  //     toDate: this.toDate
  //   }
  //   if (this.Type == 'sent') {
  //     this.sharedService.post('v1/accounting/complete_sale_list', request).subscribe((res: any) => {
  //       if (res.replyCode == "success") {
  //         // this.Tdata = res.data;
  //         // this.TTotalCount = res.count;
  //         // this.keys = Object.keys(this.Tdata[0]);
  //         this.sent_data = res.data;
  //         this.TotalCount = res.count;
  //         this.keys = Object.keys(this.sent_data[0]);
  //       }
  //     }, err => {

  //     })
  //   } else if (this.Type == 'recieved') {
  //     this.sharedService.post('v1/accounting/complete_purchase_list', request).subscribe((res: any) => {
  //       if (res.replyCode == "success") {
  //         // this.Tdata = res.data;
  //         // this.keys = Object.keys(this.Tdata[0]);
  //         // this.TTotalCount = res.count;

  //         this.recieved_data = res.data;
  //         this.keys = Object.keys(this.recieved_data[0]);
  //         this.TotalCount = res.count;
  //       }
  //     }, err => {
  //       this.toastr.errorToastr(err.replyMsg)
  //     })
  //   }
  // }


  onPageChange(event) {
    this.bodydata['page'] = event;
    this.bodydata['page_no'] = event;
    this.showList(this.bodydata);
  }

  // download() {
  //   var request = {
  //     page_limit: '',
  //     page_no: 1,
  //     // is_billed: true,
  //     sortorder: "desc",
  //     fromDate: this.fromDate,
  //     toDate: this.toDate
  //   }
  //   if (this.Type == 'sale') {
  //     this.sharedService.post('v1/accounting/complete_sale_list', request).subscribe((res: any) => {
  //       if (res.replyCode == "success") {
  //         this.Tdata = res.data;
  //         this.TTotalCount = res.count;
  //         this.keys = Object.keys(this.Tdata[0]);
  //       }
  //     }, err => {

  //     })
  //   } else if (this.Type == 'purchase') {
  //     this.sharedService.post('v1/accounting/complete_purchase_list', request).subscribe((res: any) => {
  //       if (res.replyCode == "success") {
  //         this.Tdata = res.data;
  //         this.keys = Object.keys(this.Tdata[0]);
  //         this.TTotalCount = res.count;
  //       }
  //     }, err => {
  //       this.toastr.errorToastr(err.replyMsg)
  //     })
  //   }
  //   setTimeout(() => {
  //     console.log("Tdaatatatata ::::::::::", this.Tdata)
  //     $('#Exportmodal').modal('show');
  //   }, 1000);
  // }


  exportdata(): void {
    /* table id is passed over here */
    let element = document.getElementById('contentToConvert');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'Excel-Report.xlsx');

  }


  reverseAndTimeStamp(dateString) {
    const reverse = new Date(dateString.split("-").reverse().join("-"));
    return reverse.getTime();
  }

  get fs() { return this.sendRequest.controls; }

  addrequest1(type){
    this.sendRequest.reset();
    if(type == 'balance'){
      this.usertype='balance';
      this.sendRequest = this.fb.group({
        type: ['balance', Validators.required],
        amount: ['', Validators.required],
        mode: ['', Validators.required],
        reference: ['', Validators.required],
        image: [''],
        comment: ['']
      });
    }
    else{
      this.usertype='credit'
      this.sendRequest = this.fb.group({
        type: ['credit', Validators.required],
        amount: ['', Validators.required],
        comment: ['']
      });
    }  
    $('#sentmodal').modal('show');
  }

  preview(files) {
    if (files.length === 0){ return; }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) { this.message = "Only images are supported."; return; }
    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]); 
    reader.onload = (_event) => { this.image = reader.result;  this.message=''; }
    console.log("check image path:::::::", this.image, this.imagePath);
    
  }

  onFileChanged(event) {
    this.File = event.target.files[0];
  }

  addRequest(){
    this.submitted = true;
    if (this.sendRequest.invalid) { 
      return;
    }else{
      const self=this;
      self.sharedService.loadingShow = true; 
        self.sharedService.loadingShow = true;
        const bodyObject = new FormData();
        if(this.usertype == 'balance'){
          if(self.File == null){  bodyObject.append('image','');  }else{  bodyObject.append('image', self.File, self.File.name);  }
          bodyObject.append('to_user_id', self.userAgency.id);
          bodyObject.append('type', self.sendRequest.value.type);
          bodyObject.append('amount', self.sendRequest.value.amount);
          bodyObject.append('mode', self.sendRequest.value.mode);
          bodyObject.append('reference', self.sendRequest.value.reference);
          bodyObject.append('comment', self.sendRequest.value.comment);
      }else{
          bodyObject.append('to_user_id', self.userAgency.id);
          bodyObject.append('type', self.sendRequest.value.type);
          bodyObject.append('amount', self.sendRequest.value.amount);
          bodyObject.append('comment', self.sendRequest.value.comment);
      }
      console.log("form body data list:::::::::",bodyObject);
      
        this.sharedService.postRequest('v1/request/send',bodyObject).subscribe((res)=> {
          if(res.replyCode == 'success'){
            this.submitted = false;
            this.showList(this.bodydata);
            $('#sentmodal').modal('hide');
            this.sendRequest.reset();
            this.toastr.successToastr(res.replyMsg, 'Success');
          }else{
            this.submitted = false
            $('#sentmodal').modal('hide');
            this.toastr.errorToastr(res.replyMsg, 'Error');
          }
        },err=>{
          if(err.error.replyMsg.message){
            this.submitted = false
            this.toastr.errorToastr(err.error.replyMsg.message, 'Error');
            $('#sentmodal').modal('hide');
            this.sendRequest.reset();
          }else{
            this.submitted = false
            $('#sentmodal').modal('hide');
            this.toastr.errorToastr(err.error.replyMsg, 'Error');
          }
        });
      }
  }

imgZoom(val){
  var imgVal = val;
  this.zoomimage=val
  console.log("check image value :::::::::", imgVal);
  $("#imageZoomModal").modal('show');
}
viewDetail(dataList){
  this.viewList = dataList;
  $("#viewDetail").modal('show');
}

}